'use client'
import Script from 'next/script'
import CookiesConsentBanner from './CookiesConsentBanner'
import {useState, useEffect} from 'react'

const GoogleTagManager = () => {
  const [consentExists, setConsentExists] = useState(false)
  const [hasConsented, setHasConsented] = useState(false)

  useEffect(() => {
    const stored = localStorage.getItem('cookie-consent')
    setConsentExists(stored !== null)
    setHasConsented(stored === 'true')
  }, [])

  if (!consentExists) return <CookiesConsentBanner onConsent={(consented: boolean) => { setConsentExists(true); setHasConsented(consented) }} />

  if (!hasConsented) return <></>

  const GTM_ID = 'G-7BV4E9V356'

  return (
    <>
      <Script src={`https://www.googletagmanager.com/gtag/js?id=${GTM_ID}`} strategy="afterInteractive" />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', '${GTM_ID}');
      `}
      </Script>
    </>
  )
}

export default GoogleTagManager
